import { useImpersonation } from '../../auth/useImpersonation';
import { useAuthUser } from '../../auth/useAuthUser';

/**
 * Persistent top-of-app banner shown only while an admin is "viewing as"
 * another user. Non-dismissable by design — invisible impersonation is
 * the failure mode that bites you. Closing the tab clears it via the
 * sessionStorage backing.
 */
export function ImpersonationBanner() {
  const { targetEmail, isImpersonating, clear } = useImpersonation();
  const real = useAuthUser();

  if (!isImpersonating || !targetEmail) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: '#BF360C',
        color: '#FFFFFF',
        padding: '8px 20px',
        fontFamily: "'DM Mono', monospace",
        fontSize: 12,
        letterSpacing: 0.4,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <span style={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.8 }}>
          Viewing as user
        </span>
        <span>
          {real.email && (
            <>
              <span style={{ opacity: 0.8 }}>{real.email}</span>
              <span style={{ margin: '0 8px', opacity: 0.6 }}>→</span>
            </>
          )}
          <span style={{ fontWeight: 600 }}>{targetEmail}</span>
        </span>
        <span style={{ opacity: 0.85, fontSize: 11 }}>
          Reads only — writes are blocked
        </span>
      </div>
      <button
        onClick={clear}
        style={{
          background: 'transparent',
          color: '#FFFFFF',
          border: '1px solid #FFFFFF',
          padding: '4px 12px',
          borderRadius: 4,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: 0.6,
          textTransform: 'uppercase',
          cursor: 'pointer',
          fontFamily: 'inherit',
          whiteSpace: 'nowrap',
        }}
      >
        Exit
      </button>
    </div>
  );
}
